export class CreateFabricTableShortcutDemoRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "shortcuts",
            "baseName": "shortcuts",
            "type": "Array<CreateFabricTableShortcutDemoRequestShortcutsInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateFabricTableShortcutDemoRequest.attributeTypeMap;
    }
    constructor() {
    }
}
